import React, { useRef, useState } from "react";

const Staff = () => {
  const nameRef = useRef();
  const phoneRef = useRef();
  const emailRef = useRef();
  const dobRef = useRef();
  const designationRef = useRef();
  const departmentRef = useRef();
  const empTypeRef = useRef();
  const statusRef = useRef();
  const aadharRef = useRef();
  const passportRef = useRef();
  const licenseRef = useRef();

  const [educationList, setEducationList] = useState([]);
  const [submittedList, setSubmittedList] = useState([]);
  const [errors, setErrors] = useState([]);

  const handleAddEducation = () => {
    setEducationList([
      ...educationList,
      {
        id: Date.now(),
        level: "",
        qualification: "",
        board: "",
        institution: "",
        year: "",
        percentage: "",
      },
    ]);
  };

  const handleRemoveEducation = (id) => {
    setEducationList(educationList.filter((edu) => edu.id !== id));
  };

  const handleEducationChange = (id, field, value) => {
    const updatedList = educationList.map((edu) =>
      edu.id === id ? { ...edu, [field]: value } : edu
    );
    setEducationList(updatedList);
  };

  const resetForm = () => {
    nameRef.current.value = "";
    phoneRef.current.value = "";
    emailRef.current.value = "";
    dobRef.current.value = "";
    designationRef.current.value = "";
    departmentRef.current.value = "";
    empTypeRef.current.value = "";
    statusRef.current.value = "";
    aadharRef.current.value = "";
    passportRef.current.value = "";
    licenseRef.current.value = "";
    setEducationList([]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = [];

    if (!nameRef.current.value) errs.push("Name is required");
    if (!phoneRef.current.value) errs.push("Phone is required");
    if (!emailRef.current.value) errs.push("Email is required");
    if (!designationRef.current.value) errs.push("Designation is required");
    if (!departmentRef.current.value) errs.push("Department is required");
    if (!empTypeRef.current.value) errs.push("Employment Type is required");
    if (!aadharRef.current.value) errs.push("Aadhar Number is required");
    if (educationList.length === 0) errs.push("At least one education record required");

    if (errs.length > 0) {
      setErrors(errs);
      return;
    }

    const newEntry = {
      Name: nameRef.current.value,
      Phone: phoneRef.current.value,
      Email: emailRef.current.value,
      DOB: dobRef.current.value,
      Designation: designationRef.current.value,
      Department: departmentRef.current.value,
      "Employment Type": empTypeRef.current.value,
      "Employee Status": statusRef.current.value,
      "Aadhar Number": aadharRef.current.value,
      "Passport Number": passportRef.current.value,
      "Driving License": licenseRef.current.value,
      Education: [...educationList],
    };

    setSubmittedList((prev) => [...prev, newEntry]);
    setErrors([]);
    resetForm(); // clear inputs and education after submit
  };

  return (
    <div className="max-w-5xl mx-auto p-6">
      <h2 className="text-2xl font-bold mb-4 text-blue-700">🧾 Employee Onboarding</h2>

      {errors.length > 0 && (
        <div className="bg-red-100 text-red-700 p-3 rounded mb-4">
          <ul className="list-disc pl-5">
            {errors.map((err, idx) => (
              <li key={idx}>{err}</li>
            ))}
          </ul>
        </div>
      )}

      <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">
        <input ref={nameRef} placeholder="Name*" className="border p-2 rounded" />
        <input ref={phoneRef} placeholder="Phone Number*" className="border p-2 rounded" />
        <input ref={emailRef} placeholder="Email*" className="border p-2 rounded" />
        <input ref={dobRef} type="date" className="border p-2 rounded" />

        <input ref={designationRef} placeholder="Designation*" className="border p-2 rounded" />
        <input ref={departmentRef} placeholder="Department*" className="border p-2 rounded" />
        <select ref={empTypeRef} className="border p-2 rounded">
          <option value="">Employment Type*</option>
          <option>Full-Time</option>
          <option>Part-Time</option>
          <option>Contract</option>
          <option>Intern</option>
        </select>
        <select ref={statusRef} className="border p-2 rounded">
          <option value="">Employee Status</option>
          <option>Active</option>
          <option>On Leave</option>
          <option>Resigned</option>
          <option>Terminated</option>
        </select>

        <input ref={aadharRef} placeholder="Aadhar Number*" className="border p-2 rounded" />
        <input ref={passportRef} placeholder="Passport Number" className="border p-2 rounded" />
        <input ref={licenseRef} placeholder="Driving License" className="border p-2 rounded" />
      </form>

      <div className="mt-6">
        <h3 className="text-lg font-semibold mb-2">🎓 Education Details</h3>
        {educationList.map((edu) => (
          <div
            key={edu.id}
            className="grid grid-cols-2 gap-3 p-4 mb-4 border rounded bg-gray-50"
          >
            <select
              value={edu.level}
              onChange={(e) => handleEducationChange(edu.id, "level", e.target.value)}
              className="border p-2 rounded"
            >
              <option value="">Select Level</option>
              <option>10th</option>
              <option>Inter</option>
              <option>Undergraduate</option>
              <option>Postgraduate</option>
            </select>
            <input
              value={edu.qualification}
              onChange={(e) => handleEducationChange(edu.id, "qualification", e.target.value)}
              placeholder="Qualification"
              className="border p-2 rounded"
            />
            <input
              value={edu.board}
              onChange={(e) => handleEducationChange(edu.id, "board", e.target.value)}
              placeholder="Board/University"
              className="border p-2 rounded"
            />
            <input
              value={edu.institution}
              onChange={(e) => handleEducationChange(edu.id, "institution", e.target.value)}
              placeholder="School/College Name"
              className="border p-2 rounded"
            />
            <input
              value={edu.year}
              onChange={(e) => handleEducationChange(edu.id, "year", e.target.value)}
              placeholder="Year of Passing"
              className="border p-2 rounded"
            />
            <input
              value={edu.percentage}
              onChange={(e) => handleEducationChange(edu.id, "percentage", e.target.value)}
              placeholder="Percentage / CGPA"
              className="border p-2 rounded"
            />
            <button
              type="button"
              onClick={() => handleRemoveEducation(edu.id)}
              className="col-span-2 text-red-600 underline text-sm mt-1"
            >
              Remove This Education
            </button>
          </div>
        ))}

        <button
          onClick={handleAddEducation}
          type="button"
          className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
        >
          ➕ Add Education
        </button>
      </div>

     <div className="mt-6">
  <button
    type="submit"
    onClick={handleSubmit}
    className="bg-blue-600 text-white py-2 px-6 rounded hover:bg-blue-700 w-full sm:w-auto"
  >
    Save Employee
  </button>
</div>

<div className="mt-4">
  <button
    type="button"
   
    className="bg-blue-600 text-white py-2 px-6 rounded hover:bg-blue-700 w-full sm:w-auto"
  >
    Drive Detail
  </button>
</div>
      {/* Submitted Employees */}
      {submittedList.length > 0 && (
        <div className="mt-10">
          <h3 className="text-xl font-semibold mb-4 text-green-700">✅ All Submissions</h3>
          {submittedList.map((entry, index) => (
            <div key={index} className="mb-6 p-4 border rounded shadow-sm bg-white">
              <strong className="text-gray-800">👤 Employee #{index + 1}</strong>
              <div className="grid grid-cols-2 gap-3 text-sm mt-2">
                {Object.entries(entry).map(([key, value]) => (
                  <div key={key} className="bg-gray-50 p-2 rounded border">
                    <strong className="text-gray-700">{key}:</strong><br />
                    {Array.isArray(value) ? (
                      <ul className="list-disc pl-5">
                        {value.map((edu, i) => (
                          <li key={i}>
                            {edu.level} - {edu.qualification} - {edu.board} - {edu.institution} -{" "}
                            {edu.year} - {edu.percentage}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      value
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Staff;
